import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MagnifyingGlass } from "@phosphor-icons/react";

export const STATUS_OPTIONS = [
  { value: "all", label: "All open" },
  { value: "forecasted", label: "Forecasted" },
  { value: "posted", label: "Posted" },
  { value: "closed", label: "Closed" },
];

export const AGENCY_OPTIONS = [
  { value: "all", label: "All agencies" },
  { value: "HHS", label: "Health & Human Services" },
  { value: "NSF", label: "National Science Foundation" },
  { value: "DOE", label: "Department of Energy" },
  { value: "USDA", label: "Dept of Agriculture" },
  { value: "ED", label: "Department of Education" },
  { value: "DOT", label: "Department of Transportation" },
  { value: "EPA", label: "Environmental Protection Agency" },
  { value: "DOD", label: "Department of Defense" },
];

export default function SearchFiltersForm({
  keyword, setKeyword,
  status, setStatus,
  agency, setAgency,
  loading, hitCount,
  onSubmit,
}) {
  return (
    <form onSubmit={onSubmit} className="mt-8 border border-zinc-200 bg-white p-5" data-testid="search-form">
      <div className="grid md:grid-cols-12 gap-3">
        <div className="md:col-span-6">
          <Label className="gf-overline">Keyword / Topic</Label>
          <div className="relative mt-2">
            <MagnifyingGlass size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
            <Input
              data-testid="search-keyword"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="e.g., 'rural broadband', 'early childhood literacy'"
              className="gf-sharp pl-10 border-zinc-300 bg-white"
            />
          </div>
        </div>
        <div className="md:col-span-3">
          <Label className="gf-overline">Status</Label>
          <Select value={status} onValueChange={setStatus}>
            <SelectTrigger data-testid="search-status" className="gf-sharp mt-2 border-zinc-300 bg-white">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="gf-sharp">
              {STATUS_OPTIONS.map((o) => (
                <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="md:col-span-3">
          <Label className="gf-overline">Agency</Label>
          <Select value={agency} onValueChange={setAgency}>
            <SelectTrigger data-testid="search-agency" className="gf-sharp mt-2 border-zinc-300 bg-white">
              <SelectValue />
            </SelectTrigger>
            <SelectContent className="gf-sharp">
              {AGENCY_OPTIONS.map((o) => (
                <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="mt-4 flex items-center justify-between">
        <div className="gf-overline">
          {hitCount > 0 && `${hitCount.toLocaleString()} matching opportunities`}
        </div>
        <Button
          type="submit"
          disabled={loading}
          data-testid="search-submit"
          className="gf-sharp bg-blue-700 hover:bg-blue-800 text-white font-bold uppercase tracking-wide px-6"
        >
          {loading ? "Searching…" : "Search grants"}
        </Button>
      </div>
    </form>
  );
}
